import { NgModule } from '@angular/core';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { MeetingSchedulerI18NModule } from '../i18n/i18n.module';

@NgModule({
  declarations: [],
  imports: [GalaxySnackbarModule, MeetingSchedulerI18NModule],
  providers: [],
})
export class MeetingSchedulerServiceModule {}
